import useDocumentTitle from '../../../hooks/useDocumentTitle';
import useDocumentFilters from '../../../components/filters/DocumentFilterHelper';
import DraftDocumentListFilters from '../../../components/filters/DraftDocumentListFilters';
import React from 'react';
import SBDraftsInvoicesTable from '../components/SBDraftsInvoicesTable';
import { Box, Stack } from '@mui/material';

const filters = [
  {
    type: 'search',
    options: [
      { key: 'document_number', placeholder: 'Invoice Number' },
      { key: 'billed_to_name', placeholder: 'Buyer Name' },
      { key: 'billed_to_phone', placeholder: 'Buyer Phone' },
      { key: 'billed_to_tin', placeholder: 'Buyer TIN' },
      { key: 'billed_to_registration_number', placeholder: 'Buyer Registration Number' },
    ],
  },
];

function SBDraftInvoiceListPage() {
  useDocumentTitle('Draft Invoice List');

  const {
    selectedFilter,
    currentQuery,
    searchTerm,
    handleDateRangeChange,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handlePaginationChange,
  } = useDocumentFilters({
    defaultQuery: { document_type: '11', status: new Set(['draft']) },
  });

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <Box mb={2}>
        <DraftDocumentListFilters
          filters={filters}
          selectedFilter={selectedFilter}
          onFilterChange={handleFilterChange}
          searchTerm={searchTerm}
          onSearchKeyPress={handleSearchKeyPress}
          onSearchChange={handleSearchChange}
          onDateRangeChange={handleDateRangeChange}
        />
      </Box>
      <SBDraftsInvoicesTable handlePaginationChange={handlePaginationChange} searchQuery={currentQuery} />
    </Stack>
  );
}

export default SBDraftInvoiceListPage;
